import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import Translation from '../../lang/Translation';
import {getSelectedResidentialAddress} from '../../selectors/selectors';
import hazardIcon from '../ui/svg/hazard-icon.svg';

import './CaliforniaWarningText.scss';

export class CaliforniaWarningText extends Component {
  constructor(props) {
    super(props);
    
    this._hasExperiment = this._hasExperiment.bind(this);
    this._isExperimentUser = this._isExperimentUser.bind(this);
  }
  
  _hasExperiment() {
    return this.props.experiments.hasOwnProperty('california_lead_warning_text_wave_01');
  }
  
  _isExperimentUser() {
    return this.props.experiments.california_lead_warning_text_wave_01 === 'v1|text_visible';
  }
  
  render() {
    const shouldShow = this.props.isEnabled && ((this.props.isVisible && !this._hasExperiment())
      || (this.props.isVisible && this._hasExperiment() && this._isExperimentUser()));
    if (shouldShow) {
      return (
        <div className="CaliforniaWarningText">
          <div className="CaliforniaWarningText__message">
            <img
              src={hazardIcon}
              className="CaliforniaWarningText__hazardIcon"
              alt="hazard"
            />
            <div className="CaliforniaWarningText__text">
              <Translation
                tagProps={[
                  {},
                  {rel: 'external', target: '_blank', href: 'https://www.p65warnings.ca.gov/products/food'},
                ]}
              >
                checkout.ca.lead.warning.text
              </Translation>
            </div>
          </div>
        </div>
      );
    }
    
    return null;
  }
}

CaliforniaWarningText.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  experiments: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const data = getSelectedResidentialAddress(state);
  
  return {
    isVisible: data?.country === 'US' && data?.county === 'CA',
    experiments: state.start.siteDataV2.clientExperiments,
    isEnabled: state.site.showCaLeadWarning,
  };
};

export default connect(mapStateToProps)(CaliforniaWarningText);
